import React from "react";
import { Text } from "../text";

type InputErrorProps = React.ComponentProps<typeof Text> & {
  validationStatus?: "error" | "success" | "warning";
};

const InputError = React.forwardRef<HTMLDivElement, InputErrorProps>(
  ({ children, validationStatus = "error", ...props }, ref) => {
    return (
      <Text
        size="sm"
        className="p-input-error"
        lineHeight={"base"}
        as="div"
        color="red"
        variant="default"
        data-validation-status={validationStatus}
        ref={ref}
        {...props}
      >
        {children}
      </Text>
    );
  }
);

InputError.displayName = "InputError";

export default InputError;
